
























import moment from 'moment';
import { Vue, Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class SubjectForm5 extends Vue {
  @PropSync('subSyncDefs') syncSubSyncDefs!: any;

  time = moment('00:00:00', 'HH:mm:ss');
  date = moment().format('YYYY-MM-DD');
  type = 0;

  created() {
    this.onSyncSubSyncDefsChange();
  }

  @Watch('syncSubSyncDefs')
  onSyncSubSyncDefsChange() {
    this.date = this.syncSubSyncDefs.jobConfig?.runDateFormat || moment().format('YYYY-MM-DD');
    this.time = this.syncSubSyncDefs.jobConfig?.runDateStr || moment('00:00:00', 'HH:mm:ss');
    this.type = this.syncSubSyncDefs.jobConfig?.rate;
    this.changeCron();
  }

  changeCron() {
    let month = moment(this.date).format('M');
    let day = moment(this.date).format('D');
    let hour = moment(this.time).hour();
    let minute = moment(this.time).minute();
    let second = moment(this.time).second();
    let cron = '';
    if (this.syncSubSyncDefs.jobMode == 1) {
      cron = `${second} ${minute} ${hour} ${day} ${month} ?`;
    }
    if (this.syncSubSyncDefs.jobMode == 2) {
      this.type == 0 && (cron = `${second} ${minute} ${hour} * * ?`);
      this.type == 1 && (cron = `${second} ${minute} * * * ?`);
    }
    this.syncSubSyncDefs.cronExpression = cron;
    this.syncSubSyncDefs.jobConfig = {
      rate: this.type,
      runDateFormat: moment(this.date).format(),
      runDateStr: moment(this.time).format()
    };
  }
}
